import { isNull } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';
import { Options } from 'react-select';

import { Dropdown } from '../../../../shared/dropdown/Dropdown';
import { DropdownOption } from '../../../fields';
import { Comparator } from '../../store/filterTypes';
import styles from './TableInstanceFilters.module.scss';

interface ComparatorFilterProps {
    updateFilter: (value: Comparator | null) => void;
    filter: Comparator | null;
    testId: string;
}

export const ComparatorFilter: React.FC<ComparatorFilterProps> = ({ updateFilter, filter, testId }) => {
    const comparatorOptions = useMemo(() => Object.values(Comparator).map(value => ({ value, label: value })), []);

    const comparatorValue = useMemo(() => isNull(filter) ? null : comparatorOptions.filter(({ value }) => filter === value), [filter, comparatorOptions]);

    const updateComparator = useCallback((dropdownValue: DropdownOption | Options<DropdownOption> | null) => {
        let value = null;
        if (!isNull(dropdownValue)) {
            value = (dropdownValue as DropdownOption).value as Comparator;
        }
        updateFilter(value);
    }, [updateFilter]);

    return (
        <div className={styles.comparatorFilterWrapper}>
            <Dropdown
                value={comparatorValue}
                onChange={updateComparator}
                options={comparatorOptions}
                testId={`${testId}-comparator-filter`}
                menuPlacement='bottom'
                isClearable
                menuPortalTarget={document.body}
                placeholder={Comparator.EQUAL}
            />
        </div>
    );
};
